import Model from '@ember-data/model';

import { attr } from '@ember-data/model';

export default class FieldModel extends Model {
  @attr allowedValues;
}
